import { Para, Stack } from 'ui-components';
import StepIndicator from '../StepIndicator';
import { useFormContext, useWatch } from 'react-hook-form';
import { computeBookingPrice } from '../../computeBookingPrice';
import { NewCouponInsert } from '../../CouponInsert';
import { BookingCheckoutButton, PreBookingCheckoutButton } from 'controlled-components';
import { twJoin } from 'tailwind-merge';
import { useCheckoutStore } from '../checkoutStore';

export function Step4(): React.ReactElement {
  const { getFieldState } = useFormContext();
  const selectedStore = useCheckoutStore((state) => state.selectedStore);
  const manual = useCheckoutStore((state) => state.manual);
  const scheduled = useCheckoutStore((state) => state.scheduled);
  const selectedSchedule = useCheckoutStore((state) => state.selectedSchedule);
  const selectedCoupon = useCheckoutStore((state) => state.selectedCoupon);
  const setSelectedCoupon = useCheckoutStore((state) => state.setSelectedCoupon);

  const kidCustomer = useWatch({ name: 'kidCustomer' });
  const customerName = useWatch({ name: 'name' });
  const phoneNumber = useWatch({ name: 'phone' });
  const silentBooking = useWatch({ name: 'silentBooking' });

  const isDisabled =
    !customerName ||
    !phoneNumber ||
    getFieldState('phone').invalid ||
    getFieldState('name').invalid ||
    !selectedStore ||
    (!selectedStore?.slotsAvailable && !scheduled);

  const computedPrice = computeBookingPrice({
    service: selectedStore?.service,
    coupon: selectedCoupon,
    kidCustomer,
  });

  const CheckoutButtonComponent = scheduled ? PreBookingCheckoutButton : BookingCheckoutButton;

  return (
    <>
      <StepIndicator index={4} disabled={isDisabled}>
        Checkout
      </StepIndicator>

      <Stack gap={2} className={isDisabled ? 'opacity-30' : ''}>
        <div
          className={twJoin(
            'flex items-center justify-center w-full grow',
            isDisabled ? 'opacity-50' : 'opacity-100',
          )}
        >
          <Stack direction="row" gap={2} className="align-start pb-3 w-full">
            <Para size="xl" as="span">
              Preis:
            </Para>
            <Para size="xl" as="span" weight="medium">
              {computedPrice} CHF
            </Para>
          </Stack>
        </div>

        <CheckoutButtonComponent
          disabled={isDisabled}
          amount={computedPrice}
          data={{
            manual,
            customerName,
            phoneNumber,
            silentBooking,
            kidCustomer,
            bookTime: scheduled ? selectedSchedule : undefined,
            couponCode: selectedCoupon?.code,
            storeSlug: selectedStore?.slug || '',
          }}
        />

        <NewCouponInsert disabled={isDisabled} onValidate={(coupon) => setSelectedCoupon(coupon)} />
      </Stack>
    </>
  );
}
